import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection } from '../components/LegalLayout';

const faqs = [
  {
    q: 'How do I start playing Tech Dynasty?',
    a: 'Create a free account, and you\'ll start in your garage with $5,000 and one developer — you. Ship your first product to begin growing.',
  },
  {
    q: 'Is my progress saved automatically?',
    a: 'Yes. When you\'re signed in, your empire syncs to your account, so you can continue on any device.',
  },
  {
    q: 'I lost progress or my account looks wrong. What do I do?',
    a: 'Sign in and check your Profile page first — most sync issues resolve after a fresh login. If something still looks wrong, note your account email and what happened so it\'s ready when in-app contact support ships.',
  },
  {
    q: 'Are in-game purchases required to play?',
    a: 'No. Tech Dynasty is designed to be fully playable for free. Optional purchases and rewarded ads offer cosmetics and convenience, never a pay-to-win advantage.',
  },
  {
    q: 'How do I delete my account?',
    a: 'Account deletion requests are handled per our Privacy Policy. Support for self-serve deletion is on the way — check back on this page for the latest.',
  },
  {
    q: 'When is the app coming to iOS and Android?',
    a: 'We\'re actively building it. Check the Download page for the latest availability.',
  },
];

export default function Support() {
  return (
    <LegalLayout eyebrow="Help" title="Support">
      <LegalSection title="Contact us">
        <p>
          Need help with your account, gameplay, or something else? This page —{' '}
          <strong>playtechdynasty.com/support</strong> — is the official place to find answers.
          It's linked from the app's login and settings screens, so it's always up to date.
        </p>
      </LegalSection>

      <LegalSection title="Frequently asked questions">
        <div className="space-y-5">
          {faqs.map((f) => (
            <div key={f.q}>
              <p className="font-bold text-slate-900">{f.q}</p>
              <p className="mt-1 text-sm text-slate-600">{f.a}</p>
            </div>
          ))}
        </div>
      </LegalSection>

      <LegalSection title="More resources">
        <ul className="list-disc space-y-1 pl-5">
          <li><Link to="/terms" className="font-bold text-[var(--brand-primary)] hover:underline">Terms &amp; Conditions</Link></li>
          <li><Link to="/privacy" className="font-bold text-[var(--brand-primary)] hover:underline">Privacy Policy</Link></li>
          <li><Link to="/download" className="font-bold text-[var(--brand-primary)] hover:underline">Download the app</Link></li>
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
